import { modalBodyLock, modalBodyLockClear } from './bodyLock.js';

export const cookieModal = () => {
    const cookieClose = document.querySelector('.cookies-close');
    const cookieOuter = document.querySelector('.modal-cookies-outer');
    const modalOverlay = document.querySelector('.modal-overlay');

    if (cookieOuter) {
        cookieOuter.classList.remove('hidden-modal');
        cookieClose.addEventListener('click', () => {
            cookieOuter.classList.add('hidden-modal');
            modalOverlay.classList.add('overlay-invisible');
        });
    }
};

export const siteNavOverlay = () => {
    let ScrollTop = 0;

    // const html = document.querySelector('html');
    const htmlTarget = document.querySelector('html');
    const footer = document.querySelector('footer');
    const header = document.querySelector('header');
    const modalOverlay = document.querySelector('.modal-overlay-infosect');
    const modalOverlayVacancy = document.querySelector(
        '.modal-overlay-form-application'
    );

    const jobVacancyForm = document.querySelector('#job-vacancy-form');

    const popupSectButtons = document.querySelectorAll('.popup-button');
    const modalInner = document.querySelectorAll('.modal-infosect-outer');

    const navigationLinks = document.querySelectorAll('.navigation-link');

    const infoClose = document.querySelectorAll('.info-popup-close');
    const infoCloseVacancy = document.querySelector(
        '.info-popup-close-vacancy'
    );
    const infoSectionContent = document.querySelectorAll(
        '.modal-infosect-content-holder'
    );
    const vacancyButtons = document.querySelectorAll('.vacancy-modal-trigger');

    const feedbackButton = document.querySelector('#feedback-modal-trigger');
    const modalInnerFeedback = document.querySelectorAll(
        '.modal-infosect-outer-feedback'
    );
    const modalOverlayFeedback = document.querySelector(
        '.modal-overlay-form-feedback'
    );
    const infoCloseFeedback = document.querySelector(
        '.info-popup-close-feedback'
    );

    const overviewContent = document.querySelector('#overview-content');

    const hiddenAttributeForFooter = document.createAttribute('hidden');
    const hiddenAttributeForFeedback = document.createAttribute('hidden');
    const hiddenAttributeForOverviewContent =
        document.createAttribute('hidden');

    const infosectModalClose = (e) => {
        $('html :focusable').attr('tabindex', 0);
        $('h2').attr('tabindex', -1);

        for (let i = 0; i < modalInner.length; i += 1) {
            const item = modalInner[i];
            item.classList.add('hidden-modal');

            const hiddenAttributeForAccordionLayover =
                document.createAttribute('hidden');
            item.setAttributeNode(hiddenAttributeForAccordionLayover);
        }

        modalBodyLockClear(ScrollTop);

        if (e) {
            // Set the focus back to the link clicked to open the layover.

            if (e.srcElement && e.srcElement.dataset) {
                const targetId = `link-${e.srcElement.dataset.contentId}`;
                const target = document.getElementById(targetId);

                if (target) {
                    target.focus();
                }
            }
        }

        if (popupSectButtons[0]) {
            setTimeout(() => {
                modalOverlay.classList.add('overlay-invisible');
                for (let i = 0; i < infoSectionContent.length; i += 1) {
                    infoSectionContent[i].classList.remove(
                        'modal-infosect-displayed'
                    );
                }
            }, 300);
        } else if (modalOverlayVacancy && vacancyButtons) {
            modalOverlayVacancy.classList.add('overlay-invisible');
        }
    };

    const infosectModalCloseFeedback = () => {
        for (
            let i = 0, modalSect;
            (modalSect = modalInnerFeedback[i]);
            i += 1
        ) {
            modalInnerFeedback[i].classList.add('hidden-modal');
            modalInnerFeedback[i].setAttributeNode(hiddenAttributeForFeedback);

            $('html :focusable').attr('tabindex', 0);
            $('.modal-infosect-outer-feedback :focusable').attr('tabindex', -1);
        }

        modalBodyLockClear(ScrollTop);

        if (modalOverlayFeedback && feedbackButton) {
            modalOverlayFeedback.classList.add('overlay-invisible');
        }
    };

    if (modalOverlay) {
        modalOverlay.addEventListener('click', () => {
            infosectModalClose();
        });
        for (let i = 0; infoClose.length > i; i += 1) {
            infoClose[i].addEventListener('click', (e) => {
                infosectModalClose(e);
            });
        }

        for (let i = 0; i < popupSectButtons.length; i += 1) {
            // eslint-disable-next-line no-loop-func
            popupSectButtons[i].addEventListener('click', () => {
                ScrollTop = modalBodyLock();
                modalOverlay.classList.remove('overlay-invisible');
                modalInner[i].classList.remove('hidden-modal');
                modalInner[i].removeAttribute('hidden');

                $('html :focusable').attr('tabindex', -1);
                $('.modal-infosect-outer :focusable').attr('tabindex', 0);

                htmlTarget.setAttribute('data-scrolldir', 'up');
                // console.log(i);
            });
        }
    }

    const stickyButtonsObserver = document.querySelector(
        '.sticky-buttons-observer'
    );

    const morePublicationsLink = document.querySelector(
        '#show-more-publications'
    );

    const alphabetLink = document.querySelectorAll('.alphabetic-link ');

    const overlayLink = document.querySelectorAll('.overlay-link ');

    const modalBackgroudPolyclinics = document.querySelector(
        '.modal-overlay-infosect-polyclinics'
    );
    const modalInnerPolyclinics = document.querySelector(
        '.modal-infosect-outer-polyclinics'
    );
    const closeModalPolyclinics = document.querySelector(
        '.info-popup-close-polyclinics'
    );

    const polyclinicsContentHolder = document.querySelector(
        '#polyclinics-detail-content'
    );

    // alphabetic scroll modal popup

    function openAlphabetLink(alphabetLink) {
        modalBackgroudPolyclinics.classList.remove('overlay-invisible');
        modalInnerPolyclinics.classList.remove('hidden-modal');
        htmlTarget.setAttribute('data-scrolldir', 'up');

        closeModalPolyclinics.setAttribute(
            'data-content-id',
            alphabetLink.dataset.contentId
        );

        // eslint-disable-next-line no-use-before-define
        showAlphabetDetailInfo(alphabetLink.dataset.contentId);

        ScrollTop = modalBodyLock();
    }

    if (stickyButtonsObserver || morePublicationsLink) {
        for (let i = 0; i < alphabetLink.length; i += 1) {
            // eslint-disable-next-line no-loop-func
            alphabetLink[i].addEventListener('click', () => {
                openAlphabetLink(alphabetLink[i]);
            });

            alphabetLink[i].addEventListener('keypress', (event) => {
                if (event.key === 'Enter') {
                    alphabetLink[i].click();
                }
            });
        }

        if (morePublicationsLink) {
            // eslint-disable-next-line no-loop-func
            morePublicationsLink.addEventListener('click', () => {
                modalBackgroudPolyclinics.classList.remove('overlay-invisible');
                modalInnerPolyclinics.classList.remove('hidden-modal');
                htmlTarget.setAttribute('data-scrolldir', 'up');

                // eslint-disable-next-line no-use-before-define
                showAlphabetDetailInfo(morePublicationsLink.dataset.contentId);

                ScrollTop = modalBodyLock();
            });
        }

        if (closeModalPolyclinics) {
            closeModalPolyclinics.addEventListener('click', () => {
                modalBackgroudPolyclinics.classList.add('overlay-invisible');
                modalInnerPolyclinics.classList.add('hidden-modal');

                $('#polyclinics-detail-content').html('');

                const targetId = `link-${closeModalPolyclinics.getAttribute(
                    'data-content-id'
                )}`;

                overviewContent.removeAttribute('hidden');
                footer.removeAttribute('hidden');
                modalBodyLockClear(ScrollTop);

                if (document.getElementById(targetId)) {
                    document.getElementById(targetId).focus();
                }
            });
        }

        if (modalBackgroudPolyclinics) {
            modalBackgroudPolyclinics.addEventListener('click', () => {
                modalBackgroudPolyclinics.classList.add('overlay-invisible');
                modalInnerPolyclinics.classList.add('hidden-modal');
                modalBodyLockClear(ScrollTop);
            });
        }
    }

    const showAlphabetDetailInfo = (contentId) => {
        // make a ajax call to the server
        if (!polyclinicsContentHolder) {
            return;
        }
        const baseUrl = polyclinicsContentHolder.dataset.apiUrl;

        const url = `${baseUrl}?contentId=${contentId}`;

        const loaderMessage = document.querySelector('#loader-message');

        if (loaderMessage) {
            $.blockUI({
                message: $('#loader-message'),
            });
        }

        // eslint-disable-next-line consistent-return
        return fetch(url)
            .then((response) => response.text())
            .then((data) => {
                polyclinicsContentHolder.style.visibility = 'visible';
                polyclinicsContentHolder.style.display = 'block';
                polyclinicsContentHolder.innerHTML = data;

                overviewContent.setAttributeNode(
                    hiddenAttributeForOverviewContent
                );
                footer.setAttributeNode(hiddenAttributeForFooter);

                $.unblockUI();
            })
            .catch((ex) => {
                // eslint-disable-next-line no-console
                console.log('error', ex);
            });
    };

    const videoClick = document.querySelectorAll('.square-image-video');
    const videoModalClose = document.querySelectorAll('.video-modal-close');

    const videoCarouselOverlay = document.querySelectorAll(
        '.modal-video-overlay'
    );
    const videoCarouselClose = document.querySelectorAll('.video-modal-close');

    if (videoClick[0]) {
        for (let i = 0; i < videoClick.length; i += 1) {
            // eslint-disable-next-line no-loop-func
            videoClick[i].addEventListener('click', () => {
                videoCarouselOverlay[i].classList.remove('hidden-modal');
                videoCarouselOverlay[i].classList.add('active');
                videoCarouselOverlay[i].removeAttribute('hidden');
                ScrollTop = modalBodyLock();

                const { videoId } = videoClick[i].dataset;

                playVideo(videoId);
            });
        }
        for (let i = 0; i < videoCarouselClose.length; i += 1) {
            // eslint-disable-next-line no-loop-func
            videoCarouselClose[i].addEventListener('click', () => {
                for (let j = 0; j < videoCarouselOverlay.length; j += 1) {
                    videoCarouselOverlay[j].classList.add('hidden-modal');
                    videoCarouselOverlay[i].classList.remove('active');

                    const hiddenAttributeForVideoPlayer =
                        document.createAttribute('hidden');

                    videoCarouselOverlay[j].setAttributeNode(
                        hiddenAttributeForVideoPlayer
                    );
                }
                modalBodyLockClear(ScrollTop);
            });
        }
    }

    var playVideo = (videoBlockId) => {
        const videoIframe = document.getElementById(`iframe-${videoBlockId}`);

        if (!videoIframe) {
            return;
        }

        videoIframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'playVideo',
            }),
            '*'
        );

        videoIframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'unMute',
            }),
            '*'
        );
    };

    if (videoModalClose[0]) {
        for (let i = 0; i < videoModalClose.length; i += 1) {
            // eslint-disable-next-line no-loop-func
            videoModalClose[i].addEventListener('click', () => {
                pauseAllYouTubeVideos();
            });
        }
    }

    var pauseAllYouTubeVideos = () => {
        const iframes = document.querySelectorAll('iframe');
        Array.prototype.forEach.call(iframes, (iframe) => {
            iframe.contentWindow.postMessage(
                JSON.stringify({
                    event: 'command',
                    func: 'pauseVideo',
                }),
                '*'
            );
        });
    };

    if (vacancyButtons[0]) {
        vacancyButtons.forEach((vacancyButton) => {
            vacancyButton.addEventListener('click', () => {
                if (
                    modalOverlayVacancy.classList.contains(
                        'overlay-invisible'
                    ) ||
                    modalInner.classList.contains('hidden-modal')
                ) {
                    modalOverlayVacancy.classList.remove('overlay-invisible');
                    modalInner[0].classList.remove('hidden-modal');
                    htmlTarget.setAttribute('data-scrolldir', 'up');

                    jobVacancyForm.removeAttribute('hidden');
                    $('html :focusable').attr('tabindex', -1);
                    $('#job-vacancy-form :focusable').attr('tabindex', 0);

                    ScrollTop = modalBodyLock();
                }
            });
        });
        infoCloseVacancy.addEventListener('click', () => {
            infosectModalClose();
        });
    }

    if (feedbackButton) {
        feedbackButton.addEventListener('click', () => {
            if (
                modalOverlayFeedback.classList.contains('overlay-invisible') ||
                modalInnerFeedback.classList.contains('hidden-modal')
            ) {
                modalOverlayFeedback.classList.remove('overlay-invisible');
                modalInnerFeedback[0].removeAttribute('hidden');
                modalInnerFeedback[0].classList.remove('hidden-modal');

                $('html :focusable').attr('tabindex', -1);
                $('.modal-infosect-outer-feedback :focusable').attr(
                    'tabindex',
                    0
                );

                htmlTarget.setAttribute('data-scrolldir', 'up');
                ScrollTop = modalBodyLock();

                const { formUrl } = feedbackButton.dataset;
                $('#target-div').load(formUrl);
            }

            return false;
        });

        if (!infoCloseFeedback) {
            console.info(`No 'infoCloseFeedback' element fount within the DOM`);
        } else {
            infoCloseFeedback.addEventListener('click', () => {
                infosectModalCloseFeedback();
            });

            infoCloseFeedback.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    infosectModalCloseFeedback();
                }
            });
        }
    }

    const carouselOverlay = document.querySelectorAll(
        '.modal-carousel-overlay'
    );
    const carouselClose = document.querySelectorAll('.carousel-modal-close');
    const carouselOverlayTrigger = document.querySelectorAll(
        '.carousel-image-trigger'
    );
    const carouselInner = document.querySelectorAll(
        '.carousel-image-in-overlay'
    );

    if (carouselOverlayTrigger[0]) {
        for (let i = 0; i < carouselOverlayTrigger.length; i += 1) {
            // eslint-disable-next-line no-loop-func
            carouselOverlayTrigger[i].addEventListener('click', () => {
                carouselInner[i].classList.remove('hidden-swiper');
                carouselOverlay[i].classList.remove('hidden-modal');
                ScrollTop = modalBodyLock();
            });
        }
        for (let i = 0; i < carouselClose.length; i += 1) {
            // eslint-disable-next-line no-loop-func
            carouselClose[i].addEventListener('click', () => {
                carouselOverlay[i].classList.add('hidden-modal');
                modalBodyLockClear(ScrollTop);
                carouselInner.forEach((carousel) => {
                    setTimeout(() => {
                        carousel.classList.add('hidden-swiper');
                    }, 500);
                });
            });
        }
    }
};
